import { invokeApig }   from "../libs/awsLib";
import { WhiteLabel }   from "../utils/WhiteLabelProps";
import AWS from "aws-sdk";

WhiteLabel();
var company_id   = sessionStorage.getItem('company_id');
var company_name = sessionStorage.getItem('company_name');
var subdomain    = sessionStorage.getItem('subdomain');

var signup_url     = sessionStorage.getItem('new_sign_up_url');
var reset_password = sessionStorage.getItem('reset_password_url');

export const getAdminUserId = () => {
    var globalAdminUserId = localStorage.getItem('globalAdminUserId');
    return globalAdminUserId;
}

export const invokeGetAppMainUserId = (email, company_id) => {
    //var globalAdminUserId = getAdminUserId();
    // DO NOT USE globalAdminUserId because if first login there will be no USER ID //
    return invokeApig({
        path: `/utils/getAppMainUserId`,
        method: "POST",
        body: { screen: "getAppMainUserId", company_id: company_id, email: email } //user_id: globalAdminUserId,
    });
}


export const invokeSetTrackUserLogins = (user_id) => {

    return invokeApig({
        path: `/utils/getAppMainUserId`,
        method: "POST",
        body: { screen: "setTrackUserLogins", user_id: user_id } //user_id: globalAdminUserId,
    });
}


export const invokeSuspendMemberAccount = (email, suspend) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getAppMainUserId`,
        method: "POST",
        body: { screen: "suspendMemberAccount", user_id: globalAdminUserId, email: email, suspend: suspend }
    });
}

/*****************************************************************************************************/
/***********************************         ZOOM SECTION         ************************************/
/*****************************************************************************************************/

export const invokeGetZoom = async (user_role) => {

    return await invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "generateZoomSignature", company_id: company_id, role: user_role }
    });
}

/*****************************************************************************************************/
/***********************************       REMINDER SECTION       ************************************/
/*****************************************************************************************************/

export const invokeSetCreateReminder = (title, assigned_to, date, time, notes) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "setAddReminder", user_id: globalAdminUserId, title: title, assigned_to: assigned_to, date: date, time: time, notes: notes }
    });
}
/*************************************************************************************************/
/***********************************       HELP SECTION       ************************************/
/*************************************************************************************************/

export const invokeGetTrainerListAll = () => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "getTrainerListAll", user_id: globalAdminUserId, company_id: company_id }
    });
}

export const invokeGetHelpDetail = (help_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "getHelpDetail", user_id: globalAdminUserId, help_id: help_id }
    });
}

export const invokeGetHelpListAll = () => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "getHelpList", user_id: globalAdminUserId }
    });
}

export const invokeSetAddHelpFAQ = (help_id, youtube_id, question, answer) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "setAddHelpFAQ", user_id: globalAdminUserId, help_id: help_id, youtube_id: youtube_id, question: question, answer: answer }
    });
}

export const invokeGetHelpFAQ = (uid) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "getHelpFAQ", user_id: globalAdminUserId, uid: uid }
    });
}

export const invokeSetDeleteHelpFAQ = (uid) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "setDeleteHelpFAQ", user_id: globalAdminUserId, uid: uid }
    });
}

export const invokeGetSearchHelpFAQs = (search_term) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/utils/getSetHelp`,
        method: "POST",
        body: { screen: "getSearchHelpFAQs", user_id: globalAdminUserId, search_term: search_term }
    });
}

/*************************  DASHBOARD FUNCTIONS  *************************/
export const invokeGetDashboardAllMemberPrograms = () => {
    var globalAdminUserId = getAdminUserId();
    var adminUserRoleId   = localStorage.getItem('globalAdminUserRoleId');
    //console.log("AWSInvoke Dashboard company_id: " + company_id);

    return invokeApig({
        path: "/dashboard/getDashboard",
        method: "POST",
        body: { screen: "getDashboardAllMemberPrograms", admin_user_role_id: adminUserRoleId, company_id: company_id, user_id: globalAdminUserId }
    });
}

/************************* PROGRAM  FUNCTIONS *************************/
export const invokeSetAddNewBlockMonthView = (day_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setAddNewBlockMonthView", user_id: globalAdminUserId, day_id: day_id }
    });
}

export const invokeSetAddFreeFormBlockMonthView = (day_id, exercise_index, exercise_id, notes) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setAddFreeFormBlockMonthView", user_id: globalAdminUserId, day_id: day_id, exercise_index: exercise_index, exercise_id: exercise_id, notes: notes }
    });
}

export const invokeGetEditMonthViewExercise = (program_id, set_id, exercise_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"getEditMonthViewExercise", user_id: globalAdminUserId, program_id: program_id, set_id: set_id, exercise_id: exercise_id }
    });
}

export const invokeSetEditMonthViewExercise = (set_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setEditMonthViewExercise", user_id: globalAdminUserId, set_id: set_id }
    });
}

export const invokeSetAddMonthViewNewExercise = (subscreen, program_id, day_id, block_id, current_set_id, exercise_id, exercise_order, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, notes) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram", //`/program/${this.props.match.params.id}`,
        method: "POST",
        body: { screen:"setAddMonthViewNewExercise", subscreen: subscreen, user_id: globalAdminUserId, program_id: program_id, day_id: day_id, block_id: block_id, current_set_id: current_set_id, exercise_id: exercise_id, exercise_order: exercise_order, row_1_id: row_1_id, row_2_id: row_2_id, row_3_id: row_3_id, row_4_id: row_4_id, row_1_arr: row_1_arr, row_2_arr: row_2_arr, row_3_arr: row_3_arr, row_4_arr: row_4_arr, notes: notes }
    });
}

export const invokeSetUpdateFullProgramFromDayView = (program_id, program_block, title, week_id, week_current, day_id, day_current) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/programs/setUpdateFullProgramFromDayView", //`/program/${this.props.match.params.id}`,
        method: "PUT",
        body: { user_id: globalAdminUserId, program_id: program_id, program_block: program_block, title:title, week_id: week_id, week_current: week_current, day_id: day_id, day_current: day_current }
    });
}

export const invokeGetProgramSummary = (program_id) => {
    var globalAdminUserId = getAdminUserId();
    //console.log("globalAdminUserId: " + globalAdminUserId);

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramSummary", user_id: globalAdminUserId, program_id: program_id }
    });
}

export const invokeGetProgramOverview = (program_id, week_id, day_id) => { // , current_week, current_day
    var globalAdminUserId = getAdminUserId();
    //console.log("globalAdminUserId: " + globalAdminUserId);

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramOverview", user_id: globalAdminUserId, program_id: program_id, week_id: week_id, day_id: day_id }
    });
}

export const invokeSetProgramSummary = (program_id, price, summary, is_priced_template) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setProgramSummary", user_id: globalAdminUserId, program_id: program_id, price: price, summary: summary, is_priced_template: is_priced_template }
    });
}


export const invokeSetTemplateTitle = (program_id, title) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setTemplateTitle", user_id: globalAdminUserId, program_id: program_id, title: title }
    });
}

export const invokeSetCreateNewProgram = (title, client_id, is_template) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setCreateNewProgram", user_id: globalAdminUserId, is_template: is_template, title: title, client_id: client_id }
    });
}

export const invokeGetProgramList = (search_term) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramList", user_id: globalAdminUserId, search_term: search_term, company_id: company_id }
    });
}

export const invokeGetClientProgramList = (client_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getClientProgramList", user_id: globalAdminUserId, client_id: client_id }
    });
}

/* OPTIMIZE THIS -  When user goes from month view to day view */
export const invokeGetSingleProgram = (program_id, week_id, week_current, day_id, day_current) => {
    var globalAdminUserId = getAdminUserId();

    /*console.log("------------------------");
    console.log("User id: " + globalAdminUserId);
    console.log("Program id: " + program_id);
    console.log("week_current: " + week_current);
    console.log("Week ID: " + week_id);
    console.log("day_current: " + day_current);
    console.log("day_id: " + day_id); /* */

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getSingleProgram", user_id: globalAdminUserId, program_id: program_id, week_id: week_id, week_current: week_current, day_id: day_id, day_current: day_current }
    });
}

export const invokeGetProgramSingleDayView = (program_id, week_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramSingleDayView", user_id: globalAdminUserId, program_id: program_id, week_id: week_id }
    });
}

export const invokeCreateProgramDay = (program_id, week_id, day_next) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setCreateProgramDay", user_id: globalAdminUserId, program_id: program_id, week_id: week_id, day_current: day_next }
    });
}

export const invokeDeleteProgramDay = (week_id, day_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setDeleteProgramDay", user_id: globalAdminUserId, week_id: week_id, day_id: day_id }
    });
}

export const invokeDuplicateProgramDay_test_new = async (day_id, week_id, total_days_in_week) => {
    var globalAdminUserId = getAdminUserId();
    var day_next   = total_days_in_week + 1;

    var run_service = await invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setDuplicateProgramDay_test_new", user_id: globalAdminUserId, week_id: week_id, day_id: day_id, day_current: day_next }
    });

    return run_service;
}

export const invokeDuplicateProgramDay_v2 = async (day_id, week_id, total_days_in_week) => {
    var globalAdminUserId = getAdminUserId();
    var day_next   = total_days_in_week + 1;

    var run_service = await invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setDuplicateProgramDay_v2", user_id: globalAdminUserId, week_id: week_id, day_id: day_id, day_current: day_next }
    });

    return run_service;
}

export const invokeDuplicateProgramDay = async (day_id, week_id, total_days_in_week) => {
    var globalAdminUserId = getAdminUserId();
    var day_next   = total_days_in_week + 1;

    var run_service = await invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setDuplicateProgramDay", user_id: globalAdminUserId, week_id: week_id, day_id: day_id, day_current: day_next }
    });

    return run_service;
}

// integrated single into a single file
export const invokeGetProgramMonthView = (program_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/program/getProgram`,
        method: "POST",
        body: { screen: "getProgramMonthView", user_id: globalAdminUserId, program_id: program_id }
    });
}

export const invokeDuplicateBlockFromMonthView = (program_id, day_id, block_id, block_name, new_block_id, new_block_order, new_set_ids_arr) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen:"setDuplicateBlockFromMonthView", user_id: globalAdminUserId, program_id: program_id, day_id: day_id, block_id: block_id, block_name: block_name, new_block_id: new_block_id, new_block_order: new_block_order, new_set_ids_arr: new_set_ids_arr }
    });
}

export const invokeCreateProgramWeek = (program_id, week_next) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/program/setProgram`,
        method: "POST",
        body: { screen:"setCreateProgramWeek", user_id: globalAdminUserId, program_id: program_id, week_current: week_next }
    });
}

export const invokeDuplicateProgramWeek = (program_id, week_id, week_next) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/program/setProgram`,
        method: "POST",
        body: { screen:"setDuplicateProgramWeek", user_id: globalAdminUserId, program_id: program_id, week_id: week_id, week_current: week_next }
    });
}

export const invokeDeleteProgramWeek = (program_id, week_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setDeleteProgramWeek", user_id: globalAdminUserId, program_id: program_id, week_id: week_id }
    });
}

export const invokeUpdateBlockFromMonthView = (title, program_id, program_month_block) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram", //`/programs/updateBlockFromMonthView`,
        method: "POST",
        body: { screen: "setUpdateBlockFromMonthView", user_id: globalAdminUserId, title: title, program_id: program_id, program_block: program_month_block }
    });
}

export const invokeSaveBlockNameToProgram = (block_id, block_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path:  "/program/setProgram",
        method: "POST",
        body: { screen: "setSaveBlockNameToProgram", user_id: globalAdminUserId, block_id: block_id, block_name: block_name}
    });
}

export const invokeSaveBlockTemplate = (block_id, category_id, block_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path:  "/program/setProgram",
        method: "POST",
        body: { screen: "setSaveBlockTemplate", user_id: globalAdminUserId, block_id: block_id, category_id: category_id, block_name: block_name}
    });
}

export const invokeEditNameBlockTemplate = (block_id, block_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path:  "/program/setProgram",
        method: "POST",
        body: { screen: "setEditNameBlockTemplate", user_id: globalAdminUserId, block_id: block_id, block_name: block_name}
    });
}

export const invokeDeleteBlockTemplate = (block_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path:  "/program/setProgram",
        method: "POST",
        body: { screen: "setDeleteBlockTemplate", user_id: globalAdminUserId, block_id: block_id}
    });
}


export const invokeGetSearchAllBlockTemplates = (search_str) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: `/program/getProgram`,
        method: "POST",
        body: { screen: "getSearchAllBlockTemplates", user_id: globalAdminUserId, search_str: search_str }
    });
}

/*******************************************************************************************/
/*****************************     PROGRAM FOLDER FUNCTIONS     ****************************/
/*******************************************************************************************/

export const invokeCreateProgramFolder = (folder_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getSetProgramFolders", //`/programs/createProgramFolder`,
        method: "POST",
        body: { screen: "setCreateProgramFolder", user_id: globalAdminUserId, folder_name: folder_name}
    });
}

export const invokeGetProgramFolders = (folder_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getSetProgramFolders", //`/programs/createProgramFolder`,
        method: "POST",
        body: { screen: "getProgramFolders", user_id: globalAdminUserId, folder_name: folder_name}
    });
}

export const invokeGetBlockTemplateList = (folder_name) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram", //`/programs/createProgramFolder`,
        method: "POST",
        body: { screen: "getBlockTemplateList", user_id: globalAdminUserId}
    });
}

export const invokeGetSingleBlockTemplate = (block_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram", //`/programs/createProgramFolder`,
        method: "POST",
        body: { screen: "getSingleBlockTemplate", user_id: globalAdminUserId, block_id: block_id}
    });
}


export const invokeSaveProgramToFolder = (program_id, folder_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getSetProgramFolders",
        method: "POST",
        body: { screen: "setSaveProgramToFolder", user_id: globalAdminUserId, program_id: program_id, folder_id: folder_id}
    });
}

////    DID THE PROGRAM DUPLICATE   ////
export const invokeCheckIfProgramDuplicated = (new_program_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "checkIfProgramDuplicated", user_id: globalAdminUserId, program_id: new_program_id}
    });
}

export const invokeDuplicateProgram = (curr_program_id, new_program_id, program_name, client_id, is_template, send_to_diff_trainer, is_priced_template, action) => {
    var globalAdminUserId    = getAdminUserId();

    /*console.log("++++++++++++++++ DUPLICATE PROGRAM NAME: " + program_name);
    console.log("program_name: " + program_name);
    console.log("is_priced_template: " + is_priced_template);
    console.log("client  id: " + client_id);
    console.log("creator id: " + globalAdminUserId);
    console.log("is_template: " + is_template);
    console.log("send_to_diff_trainer: " + send_to_diff_trainer);/* */

    ////  IF the user is sending a trainer a template and not sending a client a program,
    ////  Then the trainer id will now replace the global_admin_user_id/user_id; the trainer id = client_id
    if(send_to_diff_trainer) globalAdminUserId = client_id;

    return invokeApig({
        path: "/program/duplicateProgram",
        method: "PUT",
        body: { screen: "setDuplicateEntireProgram", user_id: globalAdminUserId, program_id: curr_program_id, new_program_id: new_program_id, program_name: program_name, client_id: client_id, is_template: is_template, is_priced_template: is_priced_template, action: action}
    });
}

export const invokeDeleteProgram = (program_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setDeleteProgram", user_id: globalAdminUserId, program_id: program_id}
    });
}

export const invokeDeleteProgramFolder = (folder_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/program/setProgram",
        method: "POST",
        body: { screen: "setDeleteProgramFolder", user_id: globalAdminUserId, folder_id: folder_id}
    });
}

export const invokeGetSearchProgramsList = (search) => {
    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getSearchProgramsList", search: search }
    });
}

/*******************************************************************************************/
/*******************************      EXERCISE FUNCTIONS      ******************************/
/*******************************************************************************************/

export const invokeAddExercise = (exercise_id, publish, name, start, execute, focus, goal, youtube, category_id, keywords) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/exercise/setExercises',
        method: "POST",
        body: { screen: "setAddSingleExercise", company_id: company_id, exercise_id: exercise_id, user_id: globalAdminUserId, publish: publish, name: name, start: start, execute: execute, focus: focus, goal: goal, youtube: youtube, category_id: category_id, keywords: keywords }
    });
}

export const invokeSetSaveMultipleExercises = (id_arr, name_arr, youtube_arr, pub_arr, start_arr, execute_arr, focus_arr, goal_arr, category_ids_arr, keywords_arr) => {
    var globalAdminUserId = getAdminUserId();
    //var company_id = sessionStorage.getItem('company_id');

    return invokeApig({
        path: '/exercise/setExercises',
        method: "POST",
        body: { screen: "setAddMultipleExercises", company_id: company_id, user_id: globalAdminUserId, exercise_id_arr: id_arr, name_arr: name_arr, youtube_arr: youtube_arr, pub_arr: pub_arr, start_arr: start_arr, execute_arr: execute_arr, focus_arr: focus_arr, goal_arr: goal_arr, category_ids_arr: category_ids_arr, keywords_arr: keywords_arr }
    });
}

export const invokeSetDuplicateExercise = (exercise_id) => {
    var globalAdminUserId = getAdminUserId();
    console.log("AWS company_id: " + company_id);

    return invokeApig({
        path: '/exercise/setExercises',
        method: "POST",
        body: { screen: "setDuplicateExercise", user_id: globalAdminUserId, exercise_id: exercise_id, company_id: company_id }
    });
}

export const invokeSetDeleteExercise= (id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/exercise/setExercises',
        method: "POST",
        body: { screen: "setDeleteExercise", user_id: globalAdminUserId, exercise_id: id }
    });
}

export const invokeGetProgramDayViewExerciseDetails = (exercise_id) => {
    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramDayViewExerciseDetails", exercise_id: exercise_id }
    });
}

export const invokeGetProgramSearchExercisesByKeyword = (search) => {

    var exerciseVideoOption = localStorage.getItem('exercise_video_options');

    //console.log("Search by keyword company_id: " + company_id);
    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramSearchExercisesByKeyword", search: search, searchVideos: exerciseVideoOption, company_id: company_id }
    });
}

export const invokeGetProgramDayViewSearchExercises = (search) => {

    var exerciseVideoOption = localStorage.getItem('exercise_video_options');

    return invokeApig({
        path: "/program/getProgram",
        method: "POST",
        body: { screen: "getProgramDayViewSearchExercises", search: search, searchVideos: exerciseVideoOption, company_id: company_id }
    });
}

export const invokeListAllExercises = () => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/exercise/getListAllExercises',
        method: "POST",
        body: { user_id: globalAdminUserId, test: test }
    });
}

export const invokeGetSearchMatrixExercises = (category_ids) => {
    return invokeApig({
        path: '/exercise/getExercises',
        method: "POST",
        body: { screen: "getSearchMatrixExercises", category_id: category_ids }
    });
}

export const invokeGetExerciseDetail = (id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/exercise/getExercises',
        method: "POST",
        body: { screen: "getNewExerciseDetail", user_id: globalAdminUserId, exercise_id: id }
    });
}

export const invokeGetExercisesListAll = (number_of_rows, sort_by) => {
    var globalAdminUserId = getAdminUserId();

    var exerciseVideoOption = localStorage.getItem('exercise_video_options');
    console.log("company_id: " + company_id);
    return invokeApig({
        path: "/exercise/getExercises",
        method: "POST",
        body: { screen: "getExercisesListAll", user_id: globalAdminUserId, searchVideos: exerciseVideoOption, number_of_rows: number_of_rows, sort_by: sort_by, company_id: company_id }
    });
}

export const invokeGetSearchExercisesListAll = (search_str, number_of_rows, sort_by) => {
    var globalAdminUserId = getAdminUserId();
    var exerciseVideoOption = localStorage.getItem('exercise_video_options');

    return invokeApig({
        path: "/exercise/getExercises",
        method: "POST",
        body: { screen: "getSearchExercisesListAll", search_str: search_str, searchVideos: exerciseVideoOption, user_id: globalAdminUserId, number_of_rows: number_of_rows, sort_by: sort_by, company_id: company_id } // ex. Side Plank
    });
}

/*************************************************************************************************/
/***********************************   ASSESSMENT REPORTING   ************************************/
/*************************************************************************************************/

// getAssessmentGirthReport
// getAssessmentBodyCompReport
// getAssessmentInBodyReport
// getAssessmentHeartAndBloodReport
// getAssessmentFMSReport
export const invokeGetClientAssessmentSpecificReport = (client_id, screen) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: screen, user_id: globalAdminUserId, company_id: company_id, client_id: client_id }
    });
}

/*export const invokeGetClientAssessmentLowerBodyPowerReport = (client_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getAssessmentLowerBodyPowerReport", user_id: globalAdminUserId, company_id: company_id, client_id: client_id }
    });
}*

export const invokeGetClientAssessmentSpinalROMReport = (client_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getAssessmentSpinalROMReport", user_id: globalAdminUserId, company_id: company_id, client_id: client_id }
    });
}*

export const invokeGetClientAssessmentStrengthReport = (client_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getAssessmentStrengthReport", user_id: globalAdminUserId, company_id: company_id, client_id: client_id }
    });
}*/

/***********************************************************************************************/
/*********************************** CLIENT PROFILE SECTION ************************************/
/***********************************************************************************************/

///// AUTO FILL  MEMBER NAME ////
export const invokeGetClientName = (company_id, search_str, user_type) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClient',
        method: "POST",
        body: { screen: "getClientName", user_id: globalAdminUserId, company_id: company_id, search_str: search_str, user_type: user_type }
    });
}

export const invokeCheckIfClientEmailExists = (email) => {
    return invokeApig({
        path: "/client/getClient",
        method: "POST",
        body: { screen: "checkIfClientEmailExists", email: email }
    });
}

export const invokeAddClientProfile = (uid, first_name, last_name, email, phone, notes, company_id, photo_id, is_trainer) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/client/setAddClientProfile",
        method: "POST",
        body: { user_id: globalAdminUserId, uid: uid, first_name: first_name, last_name: last_name, email: email, phone: phone, notes: notes, company_id: company_id, photo_id: photo_id, is_trainer: is_trainer }
    });
}

export const invokeSetAddClientToTrainerList = (client_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/client/setAddClientToTrainerList",
        method: "POST",
        body: { user_id: globalAdminUserId, client_id: client_id }
    });
}

export const invokeGetClientsListAll = (number_of_rows, sort_by, company_id, search_str) => {
    var globalAdminUserId = getAdminUserId();
    var adminUserRoleId   = localStorage.getItem('globalAdminUserRoleId');
    //console.log("adminUserRoleId: " + adminUserRoleId);
    console.log("company_id: " + company_id);
    console.log("globalAdminUserId: " + globalAdminUserId);

    /*if(adminUserRoleId == 10) {
        ////  GYM OWNERS  will see this list  ////
        var globalAdminUserId = getAdminUserId();
        console.log("company_id: " + company_id);
        //console.log("globalAdminUserId: " + globalAdminUserId);

        return invokeApig({
            path: `/utils/getSetHelp`,
            method: "POST",
            body: { screen: "getTrainerListAll", user_id: globalAdminUserId, company_id: company_id }
        });
    } else {*/

        ////  Regular Trainer Employees will see this list  ////
        return invokeApig({
            path: "/client/getClientsListAll",
            method: "POST",
            body: { user_id: globalAdminUserId, number_of_rows: number_of_rows, sort_by: sort_by, company_id: company_id, search_str: search_str, user_role_id: adminUserRoleId }
        });
    //}
}

export const invokeClientExerciseHistory = (client_id, search_str) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getClientExerciseHistory", user_id: globalAdminUserId, client_id: client_id, search_str: search_str }
    });
}

export const invokeClientSingleExerciseSetsReps = (client_id, block_id, exercise_id) => {
    var globalAdminUserId = getAdminUserId();
    console.log("block_id: " + block_id);
    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getClientSingleExerciseSetsReps", user_id: globalAdminUserId, client_id: client_id, block_id: block_id, exercise_id: exercise_id }
    });
}

export const invokeClientExerciseHistoryDetail = (client_id, exercise_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getClientExerciseHistoryDetail", user_id: globalAdminUserId, client_id: client_id, exercise_id: exercise_id }
    });
}

export const invokeGetNewClientDetail = (id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getClientDetail", user_id: globalAdminUserId, company_id: company_id, client_id: id }
    });
}

export const invokeGetTemplateSpendReport = (trainer_id, role_id) => {
    var globalAdminUserId = getAdminUserId();
    console.log("invokeGetTemplateSpendReport company_id: " + company_id);

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getTemplateSpendReport", user_id: globalAdminUserId, company_id: company_id, trainer_id: trainer_id, role_id: role_id }
    });
}

export const invokeGetTrainerProfileDetail = (trainer_id, role_id, show_single_trainer, number_of_total_results) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/getClientDetail',
        method: "POST",
        body: { screen: "getTrainerProfileDetail", user_id: globalAdminUserId, show_single_trainer: show_single_trainer, number_of_total_results: number_of_total_results, company_id: company_id, trainer_id: trainer_id, role_id: role_id }
    });
}

export const invokeSetRemoveClientFromTrainerList = (id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/setRemoveClientFromTrainerList',
        method: "POST",
        body: { user_id: globalAdminUserId, client_id: id }
    });
}

export const invokeSetDeleteClient = (id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/client/setDeleteClient',
        method: "POST",
        body: { user_id: globalAdminUserId, client_id: id }
    });
}

/************************************************************************************************/
/***********************************    DOCUMENTS SECTION    ************************************/
/************************************************************************************************/

export const invokeAddDocument = (action, client_id, company_id, file_name, document_id, uid, file_type) => {
    var globalAdminUserId = getAdminUserId();

    var identityId = AWS.config.credentials.identityId;
    //console.log("identityId: " + identityId);

    return invokeApig({
        path: "/document/setAddDocument",
        method: "POST",
        body: { user_id: globalAdminUserId, action: action, client_id: client_id, company_id: company_id, file_name: file_name, document_id: document_id, uid: uid, file_type: file_type }
    });
}

export const invokeGetDocumentDetail = (action, client_id, document_uid) => {
    var globalAdminUserId = getAdminUserId();
    /*console.log("globalAdminUserId: " + globalAdminUserId);
    console.log("action: " + action);
    console.log("client_id: " + client_id);
    console.log("document_uid: " + document_uid);*/

    return invokeApig({
        path: "/document/getDocumentDetail",
        method: "POST",
        body: { user_id: globalAdminUserId, action: action, client_id: client_id, document_uid: document_uid }
    });
}

/* used in the old version of getting all documents withoutknowing a member's id; Documents homepage
export const invokeGetClientDocumentsListAll = (client_id, company_id, number_of_rows, sort_by, search_str) => {
    return invokeApig({
        path: "/document/getClientDocumentsListAll",
        method: "POST",
        body: { number_of_rows: number_of_rows, sort_by: sort_by, search_str: search_str, client_id:client_id, company_id: company_id }
    });
}*/

export const invokeGetDocumentsListAll = (client_id, number_of_rows, sort_by, search_str) => {
    var globalAdminUserId = getAdminUserId();
    var adminUserRoleId   = localStorage.getItem('globalAdminUserRoleId');

    return invokeApig({
        path: "/document/getDocumentsListAll",
        method: "POST",
        body: { user_id: globalAdminUserId, admin_user_role_id: adminUserRoleId, number_of_rows: number_of_rows, sort_by: sort_by, search_str: search_str, company_id: company_id, client_id: client_id }
    });
}

export const invokeSetDeleteDocument = (client_id, document_uid) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/document/setDeleteDocument',
        method: "POST",
        body: { user_id: globalAdminUserId, client_id: client_id, document_uid: document_uid }
    });
}

export const invokeGetSearchClientDocuments = (client_id, document_uid) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/search/getSearchClientDocuments',
        method: "POST",
        body: { user_id: globalAdminUserId, client_id: client_id, document_uid: document_uid }
    });
}

/*******************************************************************************************/
/**********************************  ASSESSMENT SECTION  ***********************************/
/*******************************************************************************************/
export const invokeSetAddBodyCompAssessment = (action, assessment_id, client_id, height, weight, lean_tissue_mass_percent,
                                        lean_tissue_mass_weight, adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddBodyCompAssessment", action: action, assessment_id: assessment_id, client_id: client_id, height: height, weight: weight,
                lean_tissue_mass_percent: lean_tissue_mass_percent, lean_tissue_mass_weight: lean_tissue_mass_weight,
                adipose_tissue_mass_percent: adipose_tissue_mass_percent, adipose_tissue_mass_weight: adipose_tissue_mass_weight, bmi:bmi}
    });
}

export const invokeSetAddGirthAssessment = (action, assessment_id, client_id, upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left, calf_right, calf_left, arm_right, arm_left, arm_flexed_right, arm_flexed_left, forearm_right, forearm_left, neck, shoulder) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddGirthAssessment", action: action, assessment_id: assessment_id, client_id: client_id, upper_chest: upper_chest, lower_chest: lower_chest, abdomen: abdomen, waist: waist, hip: hip, thigh_right: thigh_right,
                thigh_left: thigh_left, calf_right: calf_right, calf_left: calf_left, arm_right: arm_right, arm_left: arm_left,
                arm_flexed_right: arm_flexed_right, arm_flexed_left: arm_flexed_left, forearm_right: forearm_right, forearm_left: forearm_left,
                neck: neck, shoulder: shoulder}
    });
}

export const invokeSetAddFMSAssessment = (action, assessment_id, client_id, deep_squat, left_hurdle_step, right_hurdle_step, left_inline_lunge, right_inline_lunge, left_shoulder_mobility, right_shoulder_mobility, left_active_straight_leg_raise, right_active_straight_leg_raise, trunk_stability_pushup, left_rotary_stability, right_rotary_stability, notes) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddFMSAssessment", action: action, assessment_id: assessment_id, client_id: client_id, deep_squat: deep_squat, left_hurdle_step: left_hurdle_step, right_hurdle_step: right_hurdle_step, left_inline_lunge: left_inline_lunge, right_inline_lunge: right_inline_lunge, left_shoulder_mobility: left_shoulder_mobility, right_shoulder_mobility: right_shoulder_mobility, left_active_straight_leg_raise: left_active_straight_leg_raise, right_active_straight_leg_raise: right_active_straight_leg_raise, trunk_stability_pushup: trunk_stability_pushup, left_rotary_stability: left_rotary_stability, right_rotary_stability: right_rotary_stability, notes: notes}
    });
}

export const invokeSetAddPARQAssessment = (action, assessment_id, client_id, cardio_heart_disease_cb, cardio_pulmonary_disease_cb, cardio_metabolic_disease_cb, cardio_family_history_cb, cardio_blood_pressure_cb, cardio_high_cholesterol_cb, cardio_smoking_cb, cardio_sedentary_cb, signs_age_tf, signs_shortness_breath_cb, signs_irregular_heartrate_cb, ortho_osteoporosis_cb, ortho_arthritis_cb, ortho_back_pain_cb, ortho_musculoskeletal_pain_cb, ortho_hernia_cb, ortho_surgery_cb, ortho_other_cb, lifestyle_stress_personal_rb, lifestyle_stress_work_rb, lifestyle_energy_rb, lifestyle_sleep_tf, lifestyle_water_tf, lifestyle_caffeine_tf, lifestyle_alcohol_tf, lifestyle_travel_often_cb, lifestyle_hypoglycemia_cb, lifestyle_gi_disorder_cb, lifestyle_high_triglycerides_cb, lifestyle_cancer_cb, lifestyle_pre_post_natal_cb, lifestyle_anemia_cb, lifestyle_food_allergy_cb, lifestyle_other_cb, lifestyle_rd_referral_cb, health_heart_condition_rb, health_chest_pain_during_activity_rb, health_chest_pain_no_activity_rb, health_dizziness_lose_balance_rb, health_joint_problem_rb, health_blood_pressure_drugs_rb, health_other_reasons_rb, health_medical_clearance_rb, health_clearance_date_tf, activity_occupation_tf, activity_office_worker_cb, activity_works_on_feet_cb, activity_heavy_work_cb, activity_seated_hours_tf, activity_standing_hours_tf, activity_commute_time_tf, parq_notes_ta, email, phone, phone_evening, todays_date_tf, dob,  private_trainer, emergency_contact_name, emergency_contact_phone_day, emergency_contact_phone_evening, doctors_name, doctors_phone, physical_date) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddPARQAssessment", action: action, assessment_id: assessment_id, client_id: client_id, cardio_heart_disease_cb: cardio_heart_disease_cb, cardio_pulmonary_disease_cb: cardio_pulmonary_disease_cb, cardio_metabolic_disease_cb: cardio_metabolic_disease_cb, cardio_family_history_cb: cardio_family_history_cb, cardio_blood_pressure_cb: cardio_blood_pressure_cb, cardio_high_cholesterol_cb: cardio_high_cholesterol_cb, cardio_smoking_cb: cardio_smoking_cb, cardio_sedentary_cb: cardio_sedentary_cb, signs_age_tf: signs_age_tf, signs_shortness_breath_cb: signs_shortness_breath_cb, signs_irregular_heartrate_cb: signs_irregular_heartrate_cb, ortho_osteoporosis_cb: ortho_osteoporosis_cb, ortho_arthritis_cb: ortho_arthritis_cb, ortho_back_pain_cb: ortho_back_pain_cb, ortho_musculoskeletal_pain_cb: ortho_musculoskeletal_pain_cb, ortho_hernia_cb: ortho_hernia_cb, ortho_surgery_cb: ortho_surgery_cb, ortho_other_cb: ortho_other_cb, lifestyle_stress_personal_rb: lifestyle_stress_personal_rb, lifestyle_stress_work_rb: lifestyle_stress_work_rb, lifestyle_energy_rb: lifestyle_energy_rb, lifestyle_sleep_tf: lifestyle_sleep_tf, lifestyle_water_tf: lifestyle_water_tf, lifestyle_caffeine_tf: lifestyle_caffeine_tf, lifestyle_alcohol_tf: lifestyle_alcohol_tf, lifestyle_travel_often_cb: lifestyle_travel_often_cb, lifestyle_hypoglycemia_cb: lifestyle_hypoglycemia_cb, lifestyle_gi_disorder_cb: lifestyle_gi_disorder_cb, lifestyle_high_triglycerides_cb: lifestyle_high_triglycerides_cb, lifestyle_cancer_cb: lifestyle_cancer_cb, lifestyle_pre_post_natal_cb: lifestyle_pre_post_natal_cb, lifestyle_anemia_cb: lifestyle_anemia_cb, lifestyle_food_allergy_cb: lifestyle_food_allergy_cb, lifestyle_other_cb: lifestyle_other_cb, lifestyle_rd_referral_cb: lifestyle_rd_referral_cb, health_heart_condition_rb: health_heart_condition_rb, health_chest_pain_during_activity_rb: health_chest_pain_during_activity_rb, health_chest_pain_no_activity_rb: health_chest_pain_no_activity_rb, health_dizziness_lose_balance_rb: health_dizziness_lose_balance_rb, health_joint_problem_rb: health_joint_problem_rb, health_blood_pressure_drugs_rb: health_blood_pressure_drugs_rb, health_other_reasons_rb: health_other_reasons_rb, health_medical_clearance_rb: health_medical_clearance_rb, health_clearance_date_tf: health_clearance_date_tf, activity_occupation_tf, activity_office_worker_cb, activity_works_on_feet_cb: activity_works_on_feet_cb, activity_heavy_work_cb: activity_heavy_work_cb, activity_seated_hours_tf: activity_seated_hours_tf, activity_standing_hours_tf: activity_standing_hours_tf, activity_commute_time_tf: activity_commute_time_tf, parq_notes_ta: parq_notes_ta, email: email, phone: phone, phone_evening: phone_evening, todays_date_tf:todays_date_tf, dob: dob,  private_trainer: private_trainer, emergency_contact_name: emergency_contact_name, emergency_contact_phone_day: emergency_contact_phone_day, emergency_contact_phone_evening: emergency_contact_phone_evening, doctors_name: doctors_name, doctors_phone: doctors_phone, physical_date: physical_date}
    });
}

export const invokeSetAddPrimalMovementAssessment = (action, assessment_id, client_id, squat, bend, lunge, step_up, push, pull, twist) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddPrimalMovementAssessment", action: action, assessment_id: assessment_id, client_id: client_id, squat: squat, bend: bend, lunge: lunge, step_up: step_up, push: push, pull: pull, twist: twist}
    });
}

export const invokeSetAddJointROMAssessment = (action, assessment_id, client_id, right_1st_toe_flexion, right_1st_toe_extension, right_ankle_dorsiflexion, right_ankle_plantarflexion, right_ankle_eversion, right_ankle_inversion, right_knee_extension, right_knee_flexion, right_hip_extension, right_hip_flexion, right_hip_abduction, right_hip_adduction, right_glenohumeral_flexion, right_glenohumeral_extension, right_glenohumeral_abduction, right_glenohumeral_internal_rotation, right_glenohumeral_external_rotation, right_elbow_flexion, right_elbow_extension, right_wrist_flexion, right_wrist_extension, right_wrist_radial_deviation, right_wrist_ulnar_deviation, right_thumb_flexion, right_thumb_extension, right_thumb_abduction, right_thumb_adduction, left_1st_toe_flexion, left_1st_toe_extension, left_ankle_dorsiflexion, left_ankle_plantarflexion, left_ankle_eversion, left_ankle_inversion, left_knee_extension, left_knee_flexion, left_hip_extension, left_hip_flexion, left_hip_abduction, left_hip_adduction, left_glenohumeral_flexion, left_glenohumeral_extension, left_glenohumeral_abduction, left_glenohumeral_internal_rotation, left_glenohumeral_external_rotation, left_elbow_flexion, left_elbow_extension, left_wrist_flexion, left_wrist_extension, left_wrist_radial_deviation, left_wrist_ulnar_deviation, left_thumb_flexion, left_thumb_extension, left_thumb_abduction, left_thumb_adduction, left_hip_internal_rotation, right_hip_internal_rotation, left_hip_external_rotation, right_hip_external_rotation) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddJointROMAssessment", action: action, assessment_id: assessment_id, client_id: client_id, right_1st_toe_flexion: right_1st_toe_flexion, right_1st_toe_extension: right_1st_toe_extension, right_ankle_dorsiflexion: right_ankle_dorsiflexion, right_ankle_plantarflexion: right_ankle_plantarflexion, right_ankle_eversion: right_ankle_eversion, right_ankle_inversion: right_ankle_inversion, right_knee_extension: right_knee_extension, right_knee_flexion: right_knee_flexion, right_hip_extension: right_hip_extension, right_hip_flexion: right_hip_flexion, right_hip_abduction: right_hip_abduction, right_hip_adduction: right_hip_adduction, right_glenohumeral_flexion: right_glenohumeral_flexion, right_glenohumeral_extension: right_glenohumeral_extension, right_glenohumeral_abduction: right_glenohumeral_abduction, right_glenohumeral_internal_rotation: right_glenohumeral_internal_rotation, right_glenohumeral_external_rotation: right_glenohumeral_external_rotation, right_elbow_flexion: right_elbow_flexion, right_elbow_extension: right_elbow_extension, right_wrist_flexion: right_wrist_flexion, right_wrist_extension: right_wrist_extension, right_wrist_radial_deviation: right_wrist_radial_deviation, right_wrist_ulnar_deviation: right_wrist_ulnar_deviation, right_thumb_flexion: right_thumb_flexion, right_thumb_extension: right_thumb_extension, right_thumb_abduction: right_thumb_abduction, right_thumb_adduction: right_thumb_adduction, left_1st_toe_flexion: left_1st_toe_flexion, left_1st_toe_extension: left_1st_toe_extension, left_ankle_dorsiflexion: left_ankle_dorsiflexion, left_ankle_plantarflexion: left_ankle_plantarflexion, left_ankle_eversion: left_ankle_eversion, left_ankle_inversion: left_ankle_inversion, left_knee_extension: left_knee_extension, left_knee_flexion: left_knee_flexion, left_hip_extension: left_hip_extension, left_hip_flexion: left_hip_flexion, left_hip_abduction: left_hip_abduction, left_hip_adduction: left_hip_adduction, left_glenohumeral_flexion: left_glenohumeral_flexion, left_glenohumeral_extension: left_glenohumeral_extension, left_glenohumeral_abduction: left_glenohumeral_abduction, left_glenohumeral_internal_rotation: left_glenohumeral_internal_rotation, left_glenohumeral_external_rotation: left_glenohumeral_external_rotation, left_elbow_flexion: left_elbow_flexion, left_elbow_extension: left_elbow_extension, left_wrist_flexion: left_wrist_flexion, left_wrist_extension: left_wrist_extension, left_wrist_radial_deviation: left_wrist_radial_deviation, left_wrist_ulnar_deviation: left_wrist_ulnar_deviation, left_thumb_flexion: left_thumb_flexion, left_thumb_extension: left_thumb_extension, left_thumb_abduction: left_thumb_abduction, left_thumb_adduction: left_thumb_adduction, left_hip_internal_rotation: left_hip_internal_rotation, right_hip_internal_rotation: right_hip_internal_rotation, left_hip_external_rotation: left_hip_external_rotation, right_hip_external_rotation:right_hip_external_rotation }
    });
}

export const invokeSetAddSpinalROMAssessment = (action, assessment_id, client_id, vertebral_flexion, vertebral_extension, transverse_rotation_left_cervical, transverse_rotation_right_cervical, transverse_rotation_left_thoracic, transverse_rotation_right_thoracic, lateral_flexion_left, lateral_flexion_right) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddSpinalROMAssessment", action: action, assessment_id: assessment_id, client_id: client_id, vertebral_flexion: vertebral_flexion, vertebral_extension: vertebral_extension, transverse_rotation_left_cervical: transverse_rotation_left_cervical, transverse_rotation_right_cervical: transverse_rotation_right_cervical, transverse_rotation_left_thoracic: transverse_rotation_left_thoracic, transverse_rotation_right_thoracic: transverse_rotation_right_thoracic, lateral_flexion_left: lateral_flexion_left, lateral_flexion_right: lateral_flexion_right }
    });
}

export const invokeSetAddLowerBodyPowerAssessment = (action, assessment_id, client_id, vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddLowerBodyPowerAssessment", action: action, assessment_id: assessment_id, client_id: client_id, vertical_jump: vertical_jump, broad_jump: broad_jump, lateral_bound_left: lateral_bound_left, lateral_bound_right: lateral_bound_right }
    });
}

export const invokeSetAddStrengthAssessment = (action, assessment_id, client_id, deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press, bent_over_row, clean, overhead_squat, snatch, jerk, pull_up) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddStrengthAssessment", action: action, assessment_id: assessment_id, client_id: client_id, deadlift: deadlift, back_squat: back_squat, front_squat: front_squat, hex_bar_deadlift: hex_bar_deadlift, bench_press: bench_press, bent_over_row: bent_over_row, clean: clean, overhead_squat: overhead_squat, snatch: snatch, jerk: jerk, pull_up: pull_up }
    });
}

export const invokeSetAddHeartBloodAssessment = (action, assessment_id, client_id, restingHeartRate, systolicBloodPressure, diastolicBloodPressure, heartRateVariabilityScore, hdl, ldl, totalCholesterol, totalCholesterolRatio) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddHeartBloodAssessment", action: action, assessment_id: assessment_id, client_id: client_id, restingHeartRate: restingHeartRate, systolicBloodPressure: systolicBloodPressure, diastolicBloodPressure: diastolicBloodPressure, heartRateVariabilityScore: heartRateVariabilityScore, hdl: hdl, ldl: ldl, totalCholesterol: totalCholesterol, totalCholesterolRatio: totalCholesterolRatio }
    });
}

export const invokeSetAddInBodyAssessment = (action, assessment_id, client_id, total_body_water, dry_lean_mass, body_fat_mass, pbf, smm, bmi, weight, rightArm, leftArm, trunk, rightLeg, leftLeg) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddInBodyAssessment", action: action, assessment_id: assessment_id, client_id: client_id, total_body_water: total_body_water, dry_lean_mass: dry_lean_mass, body_fat_mass: body_fat_mass, pbf:pbf, smm:smm, bmi:bmi, weight:weight, right_arm: rightArm, left_arm: leftArm, trunk: trunk, right_leg: rightLeg, left_leg: leftLeg }
    });
}

export const invokeSetAddAssessment = (action, client_id, company_id, title, assessment_content, assessment_id, assessment_type) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/assessment/setAssessment",
        method: "POST",
        body: { screen: "setAddAssessment", user_id: globalAdminUserId, action: action, client_id: client_id, company_id: company_id, title: title, assessment_content: assessment_content, uid: assessment_id, assessment_type: assessment_type }
    });
}

export const invokeSetDeleteAssessment = (client_id, assessment_id, assessment_type) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: '/assessment/setAssessment',
        method: "POST",
        body: { screen: "setDeleteAssessment", user_id: globalAdminUserId, client_id: client_id, assessment_id: assessment_id, assessment_type: assessment_type }
    });
}

export const invokeGetAssessmentDetail = (screen, action, client_id, assessment_id) => {
    var globalAdminUserId = getAdminUserId();
    console.log("screen: " + screen);
    return invokeApig({
        path: "/assessment/getAssessmentDetail",
        method: "POST",
        body: { user_id: globalAdminUserId, screen: screen, action: action, client_id: client_id, assessment_id: assessment_id }
    });
}

export const invokeGetAssessmentsListAll = (client_id, number_of_rows, sort_by, search_str) => {
    var globalAdminUserId = getAdminUserId();
    //company_id is declared above

    var adminUserRoleId   = localStorage.getItem('globalAdminUserRoleId');

    return invokeApig({
        path: "/assessment/getAssessmentsListAll",
        method: "POST",
        body: { user_id: globalAdminUserId, number_of_rows: number_of_rows, admin_user_id_role: adminUserRoleId, sort_by: sort_by, search_str: search_str, company_id: company_id, client_id: client_id }
    });
}

/********************************************************************************************/
/***********************************   MESSAGE SECTION   ************************************/
/********************************************************************************************/

export const invokeGetSummaryMessages = (creator_id, search_term, number_of_rows) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/message/getMessages",
        method: "POST",
        body: { user_id: globalAdminUserId, creator_id: creator_id, screen: "getSummaryMessages", search_term: search_term, number_of_rows: number_of_rows }
    });
}

export const invokeGetMessageDetail = (creator_id, message_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/message/getMessages",
        method: "POST",
        body: { user_id: globalAdminUserId, creator_id: creator_id, screen: "getMessageDetail", message_id: message_id, search_term: '%', number_of_rows: 50 }
    });
}

export const invokeSetMessageAdd = (creator_id, message_id, recipient_id, body) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/message/setMessages",
        method: "POST",
        body: { user_id: globalAdminUserId, creator_id: creator_id, screen: "setMessageAdd", message_id: message_id, participant_id: recipient_id, body: body }
    });
}

export const invokeSetMessageDelete = (creator_id, message_id, recipient_id) => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/message/setMessages",
        method: "POST",
        body: { user_id: globalAdminUserId, creator_id: creator_id, screen: "setMessageDelete", message_id: message_id, participant_id: recipient_id, body: null }
    });
}

export const invokeGetUnreadMessages = () => {
    var globalAdminUserId = getAdminUserId();

    return invokeApig({
        path: "/message/getUnreadMessages",
        method: "POST",
        body: { user_id: globalAdminUserId }
    });
}

/*********************************************************************************************/
/***********************************   TEXT MSG SECTION   ************************************/
/*********************************************************************************************/

/*export const invokeSendNewTextMessage = (to_phone_number) => {
    return invokeApig({
        path: "/twilio/sendNewEmailText",
        method: "POST",
        body: { to_phone_number: to_phone_number }
    });
}*/
export const invokeSendNewTextMessage = (name, phone_to) => {
    var globalAdminUserId = getAdminUserId();
    //var company_name  = company_name; // ref'd above
    //var subdomain     = subdomain;    // ref'd above

    var url 		 = "https://" + subdomain + ".trainingslate.com/message/listAll"

    return invokeApig({
        path: "/text_msg/awsSNS",
        method: "POST",
        body: { user_id: globalAdminUserId, name: name, phone_to: phone_to, company_name: company_name, subdomain: subdomain }
    });
}

export const invokeSendTrainerTextMessage = (trainer_name, trainer_id, athlete_id, message, trainer_phone) => {
    var globalAdminUserId = getAdminUserId();
    //var company_name  = company_name; // ref'd above
    //var subdomain     = subdomain;    // ref'd above
    //var url 		 = "https://" + subdomain + ".trainingslate.com/message/listAll"

    return invokeApig({
        path: "/text_msg/awsSNS",
        method: "POST",
        body: { screen: "sendTrainerTwilioText", creator_id: globalAdminUserId, company_name: company_name, trainer_name: trainer_name, trainer_phone: trainer_phone, trainer_id: trainer_id, athlete_id: athlete_id, message: message }
    });
}


/***********************************************************************************************/
/***********************************   EMAIL SEND SECTION   ************************************/
/***********************************************************************************************/

//// TEMP TRAINER ONLY SOLUTION  ////
//var trainer_url                 = "p4l-castro-trainer.trainingslate.com";
//var trainer_signup_url          = "https://"+trainer_url+"/signup";
//var reset_trainer_password_url  = "https://"+trainer_url+"/reset";
//var trainer_signup_url          = sessionStorage.getItem('new_trainer_sign_up_url');
//var reset_trainer_password_url  = sessionStorage.getItem('reset_trainer_password_url');

function getSignupResetLink (location) {
    var trainer_url                 = "p4l-"+location+"-trainer.trainingslate.com";
    var trainer_signup_url          = "https://"+trainer_url+"/signup";
    var reset_trainer_password_url  = "https://"+trainer_url+"/reset";

    //console.log("trainer_signup_url: " + trainer_signup_url);
    //console.log("reset_trainer_password_url: " + reset_trainer_password_url);

    var trainer_obj = {};
    trainer_obj.trainer_signup_url          = trainer_signup_url;
    trainer_obj.reset_trainer_password_url  = reset_trainer_password_url;

    return trainer_obj;
}
/*******************************************************************/
/***********************  TRAINER SIGNUP ONLY **********************/
export const invokeSendEmailNewTrainerSignup = (email, full_name, location) => {

    var getLoc = getSignupResetLink (location)

    return invokeApig({
        path: "/email/sendEmail",
        method: "POST",
        body: { screen: "newTrainerSignupLink", company_name: company_name, email: email, full_name: full_name, signup_url: getLoc.trainer_signup_url, reset_password: getLoc.reset_trainer_password_url }
    });
}

export const invokeSendEmailResetTrainerLoginPassword = (email, full_name, location) => {

    var getLoc = getSignupResetLink (location)

    return invokeApig({
        path: "/email/sendEmail",
        method: "POST",
        body: { screen: "resetTrainerPasswordLink", company_name: company_name, email: email, full_name: full_name, signup_url: getLoc.trainer_signup_url, reset_password: getLoc.reset_trainer_password_url }
    });
}

/*******************************************************************/
/*************************  ATHLETE SIGNUP  ************************/
export const invokeSendEmailNewUserSignup = (email, full_name) => {

    return invokeApig({
        path: "/email/sendEmail",
        method: "POST",
        body: { screen: "newUserSignupLink", company_name: company_name, email: email, full_name: full_name, signup_url: signup_url, reset_password: reset_password }
    });
}


export const invokeSendEmailResetLoginPassword = (email, full_name) => {
    return invokeApig({
        path: "/email/sendEmail",
        method: "POST",
        body: { screen: "resetPasswordLink", company_name: company_name, email: email, full_name: full_name, signup_url: signup_url, reset_password: reset_password }
    });
}



// WEBPACK FOOTER //
// ./src/utils/AwsInvoke.js